const Map = () => {
  return (
    <div style={{ width: "100%" }}>
      <iframe
        title="location-map"
        width="100%"
        height="200"
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
        src="https://maps.google.com/maps?width=100%25&amp;height=200&amp;hl=en&amp;q=Shanzu,%20Mombasa+(Siloam%20Apartments%20Limited)&amp;t=k&amp;z=15&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
      ></iframe>
    </div>
  );
};

export default Map;
